import { Globals } from "../CoreApp/Globals";
import { enumElementDrawStates } from "../constants";

export function handleSimTimer() {
  if (Globals._flashElement != null) {
    var curDrawState = Globals._flashElement.GetDrawState();
    if (curDrawState == enumElementDrawStates.MouseDown)
      Globals._flashElement.SetDrawState(enumElementDrawStates.Std);
    var wsMgr = Globals._flashElement["wsMgr"];
    Globals._flashElement["wsMgr"] = null;
    Globals._flashElement = null;
    wsMgr.RenderWS();
    if (Globals._flashTimer) {
      clearTimeout(Globals._flashTimer);
      Globals._flashTimer = null;
    }
  }
}
